import { isNonProductionHost } from '@shared/utils/environment';

/**
 * Warning strip displayed at the top of the page on every non-production environment.
 */
export const EnvironmentBanner = () => {
  if (!isNonProductionHost()) {
    return null;
  }

  return (
    <div
      className="border-b border-[#FFAB00]/40 bg-[#FFF4D6] px-4 py-1 text-center text-xs font-medium text-[#7A4F01]"
      data-slot="environment-banner"
      role="status"
    >
      Environnement de test<span className="hidden sm:inline"> ({window.location.hostname})</span> — pas la production
    </div>
  );
};
